import './App.css';
import React from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import 'react-notifications/lib/notifications.css';
import ApolloClient from './components/ApolloClient';
import { RootRouter } from './pages/Routers/RootRouter';
import { GridMemoryProvider } from 'jrgrid';
import { OneloginContext } from './utils/OneLogin/context';
import OneLoginContextUtil from './utils/OneLogin/OneLoginContextUtil';

function App() {
  const [oneloginSec, setOneloginSec] = React.useState(OneLoginContextUtil.getSec());

  React.useEffect(() => {
    if (!oneloginSec) {
      OneLoginContextUtil.initSec();
      setOneloginSec(OneLoginContextUtil.getSec());
    }
  }, []);

  React.useEffect(() => {
    window.process = { ...window.process}
  }, [])

  return (
    <OneloginContext.Provider value={{ oneloginSec }}>
      <Provider store={store}>
        <ApolloClient>
          <GridMemoryProvider>
            <RootRouter />
          </GridMemoryProvider>
        </ApolloClient>
      </Provider>
    </OneloginContext.Provider>
  );
}

export default App;
